var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1V1.77778M8 14.2222V15M15 8H14.2222M1.77778 8H1M12.9497 12.9497L12.3998 12.3998M3.60022 3.60022L3.05025 3.05025M12.9498 3.05029L12.3998 3.60027M3.60027 12.3998L3.05029 12.9498M11.1111 8C11.1111 9.71822 9.71822 11.1111 8 11.1111C6.28178 11.1111 4.88889 9.71822 4.88889 8C4.88889 6.28178 6.28178 4.88889 8 4.88889C9.71822 4.88889 11.1111 6.28178 11.1111 8Z",
    stroke: "#111827",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.4fe7482f8d3606bc497bda8f802367db.svg";
export { ForwardRef as ReactComponent };